// extracted by mini-css-extract-plugin
export var box = "_5c-0";
export var check = "_5c-1";
export var checkboxButton = "_5c-6";
export var checkboxGroup = "_5c-5";
export var disabled = "_5c-7";
export var ghost = "_5c-9";
export var input = "_5c-2";
export var label = "_5c-4";
export var normal = "_5c-8";
export var uncheck = "_5c-3";